var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "vertical tabs boss-jobtype-menu",
      attrs: { id: "boss-tabs-control-" + _vm.suffix, "data-tabs": "" },
    },
    _vm._l(_vm.masterData, function (categories, index) {
      return _c(
        "li",
        {
          key: categories.id,
          staticClass: "tabs-title boss-jobtype-menu-item",
          class: index === 0 ? "is-active" : "",
        },
        [
          _c(
            "a",
            {
              staticClass: "boss-jobtype-menu-title",
              attrs: {
                href: "#boss-categories-" + categories.id + "-" + _vm.suffix,
                "aria-selected": "true",
              },
            },
            [
              _c("span", { staticClass: "boss-jobtype-menu-title-text" }, [
                _vm._v(_vm._s(categories.name)),
              ]),
              _vm._v(" "),
              _vm.tabCount(categories.id) > 0
                ? _c("div", { staticClass: "boss-selected-item" }, [
                    _c("span", { staticClass: "boss-selected-item-text" }, [
                      _vm._v("選択中"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "boss-selected-item-number" }, [
                      _vm._v(_vm._s(_vm.tabCount(categories.id))),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }